import _defineProperty from "/codebuild/output/src2469753568/src/codestar-connections.us-west-2.amazonaws.com/git-http/603400662265/us-west-2/42625e79-deed-4f1d-8499-8b7906bc0d98/MarkAnthonyGroup/www.whiteclaw.com/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { jsx } from "react/jsx-runtime";
import * as React from "react";
import * as prismicH from "@prismicio/helpers";
import { __PRODUCTION__ } from "./lib/__PRODUCTION__.js";
import { devMsg } from "./lib/devMsg.js";
import { isInternalURL } from "./lib/isInternalURL.js";
import { usePrismicContext } from "./usePrismicContext.js";
var defaultInternalComponent = "a";
var defaultExternalComponent = "a";
var _PrismicLink = function _PrismicLink(props, ref) {
  var context = usePrismicContext();
  if (!__PRODUCTION__) {
    if ("field" in props && props.field) {
      if (!props.field.link_type) {
        console.error("[PrismicLink] This \"field\" prop value caused an error to be thrown.\n", props.field);
        throw new Error("[PrismicLink] The provided field is missing required properties to properly render a link. The link will not render. For more details, see ".concat(devMsg("missing-link-properties")));
      } else if (Object.keys(props.field).length > 1 && !("url" in props.field || "uid" in props.field || "id" in props.field)) {
        console.warn("[PrismicLink] The provided field is missing required properties to properly render a link. The link may not render correctly. For more details, see ".concat(devMsg("missing-link-properties")), props.field);
      }
    } else if ("document" in props && props.document) {
      if (!("url" in props.document || "id" in props.document)) {
        console.warn("[PrismicLink] The provided document is missing required properties to properly render a link. The link may not render correctly. For more details, see ".concat(devMsg("missing-link-properties")), props.document);
      }
    }
  }
  var linkResolver = props.linkResolver || context.linkResolver;
  var href;
  if ("href" in props) {
    href = props.href;
  } else if ("document" in props && props.document) {
    href = prismicH.asLink(props.document, linkResolver);
  } else if ("field" in props && props.field) {
    href = prismicH.asLink(props.field, linkResolver);
  }
  var isInternal = href && isInternalURL(href);
  var target = props.target || "field" in props && props.field && "target" in props.field && props.field.target || !isInternal && "_blank" || void 0;
  var rel = props.rel || (target === "_blank" ? "noopener noreferrer" : void 0);
  var InternalComponent = props.internalComponent || context.internalLinkComponent || defaultInternalComponent;
  var ExternalComponent = props.externalComponent || context.externalLinkComponent || defaultExternalComponent;
  var Component = isInternal ? InternalComponent : ExternalComponent;
  var passthroughProps = Object.assign({}, props);
  delete passthroughProps.linkResolver;
  delete passthroughProps.internalComponent;
  delete passthroughProps.externalComponent;
  delete passthroughProps.rel;
  delete passthroughProps.target;
  if ("field" in passthroughProps) {
    delete passthroughProps.field;
  } else if ("document" in passthroughProps) {
    delete passthroughProps.document;
  } else if ("href" in passthroughProps) {
    delete passthroughProps.href;
  }
  return href ? /* @__PURE__ */jsx(Component, _objectSpread(_objectSpread({}, passthroughProps), {}, {
    ref: ref,
    href: href,
    target: target,
    rel: rel
  })) : null;
};
if (!__PRODUCTION__) {
  _PrismicLink.displayName = "PrismicLink";
}
var PrismicLink = React.forwardRef(_PrismicLink);
export { PrismicLink };